import classNames from 'classnames'
import React, { HTMLAttributes } from 'react'
import './index.less'

const SJCard: React.FC<HTMLAttributes<HTMLDivElement>> = ({ children, className, onClick }) => {
  return (
    <div className={classNames('sj-card', className)} onClick={onClick}>
      {children}
    </div>
  )
}

export default SJCard
